<template>
	<div class="model_mid">
		<div class="mid_left">
			<h3>开花坐果期内环境监测及水肥灌溉情况</h3>
			<div class="mid_left_table_title">
				<div class="title_item" :class="{ title_item_active: activeIndex === 0 }" @click="addActive(0)">
					气象监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 1 }" @click="addActive(1)">
					土壤监测
				</div>
				<div class="title_item" :class="{ title_item_active: activeIndex === 2 }" @click="addActive(2)">
					水肥灌溉记录
				</div>
			</div>
			<wearth v-if="activeIndex===0" />
			<roil v-if="activeIndex===1" />
		    <fertilizer v-if="activeIndex===2"/>
		</div>
		<div class="mid_img">
			<img src="@/assets/period/4.png" alt="" />
		</div>
		<div class="mid_right">
			<div class="back_title"></div>
			<div class="agricultural_boder">
				<div class="agricultural">
					枝蔓管理：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						新梢生长超过 60cm 时绑梢；疏除过密新梢；营养枝视情况保留，培养翌年结果母枝；新梢留 10~12 叶摘心，去卷须；细弱梢不摘心、不绑缚；副梢留 2 叶摘心。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-11
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="agricultural">
					花穗处理：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						开花前 3天 疏除细弱的花穗；保留的花穗留穗尖 3~4cm ，疏除其他所有支穗；花后 2 天 用 25 mg/L 赤霉素 +2.5 mg/L 氯 吡 脲 （ CPPU ） 第 1 次 浸 穗 ， 两 周 后 用25mg/L 赤霉素第 2 次浸穗。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-11
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="agricultural">
					疏果：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						当果粒有黄豆粒大时，开始疏果，每穗留果粒 50~70 粒。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-21
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				
				<div class="agricultural">
					膨大肥：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						施用氮、 磷、 钾含量均为 17% 的复合肥 25~30kg/每亩，连续 2 次，间隔 10天 。 最后 1次施肥后滴灌 1 次。
					</div>
					<div class="agricultural_tcontent_mid">
					提醒时间：2025-5-21
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="agricultural">
					高接换种：
				</div>
				<div class="agricultural_tcontent">
					<div class="agricultural_tcontent_left">
						5 月中下旬可对果园综合性状差的老旧品种进行绿枝嫁接，翌年就可挂果。
					</div>
					<div class="agricultural_tcontent_mid">
						提醒时间：2025-5-21
					</div>
					<div class="agricultural_tcontent_right" style="color: red;">
						待提醒
					</div>
				</div>
				<div class="divider"></div>
			</div>
			<div class="control">
				<p>
					<sapn class="diseases">主要病虫害:</sapn>
					<sapn class="diseases_text">
						绿盲蝽、霜霉病、灰霉病、白粉病、炭疽病、金龟子等
					</sapn>
				</p>
				<p>
					<span class="Prevention">防治措施:</span>
					<span
						class="Prevention_text">
						25%嘧菌酯1 000 倍液+50%啶酰菌胺1 000 倍液+5%甲维盐10 000 倍液；16%氟硅唑水剂3 000 倍液+50% 啶酰菌胺1 000 倍液+5% 甲维盐10 000 倍液；科学修穗，防止后期果实挤裂，引发黑霉、酸腐。
					</span>
				</p>
		
			</div>
		
		</div>
		
	</div>
	
	<div class="model_content">
		<div class="model_content_title">开花坐果期</div>
		<div class="model_content_date">5-11 至 6-10</div>
		<div class="model_content_text">
			在开花坐果期，葡萄开始开花，随后结出小果。这是影响果实产量和品质的重要时期，需要确保充足的授粉和适宜的温湿度条件，以提高坐果率。
			
			
		</div>
	</div>
</template>

<script setup>
	import {
		ref
	} from 'vue';
	import wearth from './wearth/index.vue';
	import roil from './roil/index.vue';
	import fertilizer from './fertilizer/index.vue';

	let activeIndex = ref(0);

	function addActive(e) {
		activeIndex.value = e;
	}
</script>

<style lang="scss" scoped>
	.model_mid {
		width: 1840px;
		margin: 0 auto;
		height: 660px;
		background-image: url('../../../assets/model/mid-boder.png');
		background-size: 100% 100%;
		margin-top: 100px;
		display: flex;
		.mid_left {
				width: 660px;
				height: 540px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/mid-left.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				h3 {
					margin-left: 40px;
					color: #2dffd0;
				}
		
				.mid_left_table_title {
					width: 60%;
					display: flex;
					font-size: 14px;
					margin: 0 auto;
					margin-top: 20px;
					justify-content: space-between;
					color: #00a580;
		
					.title_item {
						flex: 1;
						text-align: center;
						padding: 5px;
					}
		
					.title_item_active {
						background-image: url('@/assets/model/mid-left-button.png');
						color: white;
						background-size: 100% 100%;
					}
				}
		
		
		
			}
		
			.mid_img {
				margin-left: 30px;
				margin-top: 200px;
			}
		
			.mid_right {
				padding: 20px;
				width: 660px;
				height: 550px;
				margin-top: 30px;
				margin-left: 30px;
				background-image: url("@/assets/model/smallboder.png");
				background-repeat: no-repeat;
				background-size: 100% 100%;
				padding-top: 14px;
		
				.back_title {
					height: 28px;
					width: 620px;
					background-image: url("@/assets/model/smalltitle.png");
					background-repeat: no-repeat;
					background-size: 100% 100%;
				}
		
				.agricultural_boder {
					font-size: 12px;
					.agricultural {
						color: #72a39f;
						margin-top: 8px;
						margin-left: 15px;
					}
		
					.agricultural_tcontent {
						width: 620px;
						display: flex;
						color: #007e62;
						margin-top: 10px;
						align-items: center;
						/* 垂直居中 */
						justify-content: space-between;
						/* 水平两端对齐 */
						padding-left: 15px;
		
						.agricultural_tcontent_left {
							text-align: justify;
							width: 380px;
						}
		
					}
		
					.divider {
						height: 2px;
						width: 100%;
						margin-top: 20px;
						background: linear-gradient(to right, transparent, #00796B, transparent);
					}
				}
		
				.control {
					color: white;
					margin-top: 10px;
					width: 100%;
					padding-left: 15px;
					text-align: justify;
					font-size: 14px;
		
		
					p {
						display: flex;
						justify-content: flex-start;
						padding-top: 15px;
					}
		
					.diseases {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
		
					}
		
					.diseases_text {
						display: inline-block;
						width: 520px;
						line-height: 20px;
						color: #007e62;
						padding-left: 20px;
					}
		
					.Prevention {
						display: inline-block;
						width: 80px;
						color: #97cac8;
						text-align: right;
					}
		
					.Prevention_text {
						display: inline-block;
						width: 520px;
						color: #007e62;
						line-height: 20px;
						padding-left: 20px;
					}
		
		
		
				}
		
			}

	}
	
	.model_content {
		width: 685px;
		height: 100px;
		margin: 0px auto;
		text-align: center;
		color: white;
		margin-top: -60px;
	
		.model_content_title {
			color: #23c9a4;
			font-size: 18px;
			font-weight: bold;
		}
	
		.model_content_date {
			margin-top: 10px;
			color: white;
			font-size: 16px;
			color: #23c9a4;
			font-weight: bold;
		}
	
		.model_content_text {
			margin-top: 10px;
			color: #23c9a4;
		}
	}
	
	
</style>